import React, { useEffect, useState } from "react";
import { makeStyles, MenuItem, TextField } from "@material-ui/core";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import Modal from "@material-ui/core/Modal";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { InputField } from "../../../../../components/input-field/InputField";
import { InputButton } from "../../../../../components/input-button/InputButton";
import { InputDate } from "../../../../../components/input-date/InputDate";
import moment from "moment";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { InputAdornment } from "@material-ui/core";

import ICIPAdminService from "../../../../../services/ICIPAdminService";
import { RaffleDrawAttributes } from "../../../../../attributes/raffle-draw-attributes";
import raffleDrawEntryService from "../../../../../services/RaffleDrawEntryService";

interface AddRaffleDrawProps {
  isOpened: boolean;
  closeCallback: () => void;
  onSubmitCallback: () => void;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "block",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
    //overflow:'hidden',
    height: "100%",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  detailsTitle: {
    fontSize: 16,
    fontWeight: "bold",
  },
  selectPackage: {
    marginTop: 30,
  },
  modalBody: {
    width: "95vw",
    padding: 10,
    border: "none",
    //overflow: "scroll",
  },

  antPickerDropdown: {
    zIndex: 100000,
  },

  inlineGrid: {
    display: "-ms-inline-flexbox",
  },
}));

export const NewRaffleDraw = (props: AddRaffleDrawProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const { formatMessage } = useIntl();
  const { isOpened, closeCallback, onSubmitCallback } = props;
  const [error, setError] = useState(false);
  const [succeed, setSucceed] = useState(false);
  const [raffleDetails, setRaffleDetails] = useState([]);
  const [positionsTab, setPositionsTab] = useState([]);
  const [packagesTab, setPackagesTab] = useState([]);
  const [numberOfDetails, setNumbersOfDetails] = useState(0);
  const [savingRaffleDraw, setSavingRaffleDraw] = useState(false);
  const [winningPackages, setWinningPackages] = useState([]);
  const [raffleDrawType, setRaffleDrawType] = useState(1);

  const onNumberOfWinner = (numberOfWinString: string) => {
    let positionsTable = [];
    let packagesTable = [];
    let detailsTab = [];
    let numberOfWin = parseInt(numberOfWinString);
    setNumbersOfDetails(numberOfWin);
    for (let index = 0; index < numberOfWin; index++) {
      detailsTab.push(index);
      positionsTable.push(index + 1);
      packagesTable.push("");
    }

    setPositionsTab(positionsTable);
    setPackagesTab(packagesTable);
    setRaffleDetails(detailsTab);
  };

  const onPositionChange = (index: number, position: string) => {
    let currentPositionsTable = [...positionsTab];
    currentPositionsTable[index] = position;
    setPositionsTab(currentPositionsTable);
  };

  const onPackageChange = (index: number, packageId: string) => {
    let currentPackageTable = [...packagesTab];
    currentPackageTable[index] = packageId;
    setPackagesTab(currentPackageTable);
  };

  const onTypeChange = (typeString: string) => {
    let type: number;
    type = parseInt(typeString);
    setRaffleDrawType(type);
  };

  const getWinningPackages = () => {
    ICIPAdminService.getWinningPackages().then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        const resultPackages = JSON.parse(JSON.stringify(response.data.data));
        setWinningPackages(resultPackages);
      }
    });
  };

  const saveRaffleDraw = () => {
    setSavingRaffleDraw(true);
    let raffleDrawData = formik.values;
    raffleDrawData["number_of_winners"] = numberOfDetails;
    console.log(raffleDrawData);
    /*raffleDrawEntryService.updateWinnersStatus(winnersTable).then((response) => {
            setSavingRaffleDraw(false);
        });*/
    setSavingRaffleDraw(false);
  };

  const formik = useFormik({
    initialValues: {
      raffle_draw_type: "1",
      renew_losers: "0",
      number_of_winners: "",
      raffle_draw_date: "",
    },
    validationSchema: Yup.object().shape({
      raffle_draw_type: Yup.string().required(
        formatMessage({ id: "sharedScreen.raffleDrawIsRequired" })
      ),
      renew_losers: Yup.string().required(
        formatMessage({ id: "sharedScreen.renewLosersIsRequired" })
      ),
      number_of_winners: Yup.string().required(
        formatMessage({ id: "sharedScreen.numberOfWinnersIsRequired" })
      ),
      raffle_draw_date: Yup.date().required(
        formatMessage({ id: "sharedScreen.raffleDrawDateIsRequired" })
      ),
    }),
    onSubmit: async (
      values: RaffleDrawAttributes,
      { setSubmitting, resetForm }: FormikHelpers<any>
    ) => {
      setError(false);
      try {
        let utcDateFormat = moment(
          values.raffle_draw_date,
          "YYYY-MM-DD HH:mm:ss"
        );
        let raffleDrawData = formik.values;

        raffleDrawData["number_of_winners"] = numberOfDetails;
        raffleDrawData["raffle_draw_date"] = utcDateFormat.utc().toISOString();
        raffleDrawData["positions"] = positionsTab;
        raffleDrawData["packages"] = packagesTab;

        const raffleDrawResult = await ICIPAdminService.createDefaultRaffleDraw(
          raffleDrawData
        );
        if (raffleDrawResult.isSuccess && raffleDrawResult.data.code === 100) {
          resetForm({});
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          onSubmitCallback();
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  const handleDateChange = (name: string, dateString: string) => {
    formik.setValues({ ...formik.values, [name]: dateString });
  };

  useEffect(() => {
    getWinningPackages();
  }, []);

  return (
    <Modal className={classes.modal} open={isOpened} onClose={closeCallback}>
      <Paper className={classes.modalBody}>
        <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
          <Grid container spacing={2}>
            <Grid
              item
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              xs={12}
              sm={12}
              lg={12}
            >
              <Typography
                className={classes.modalTitle}
                variant="h4"
                component="h4"
              >
                <FormattedMessage id="sharedScreen.newRaffleDraw" />
              </Typography>
              <IconButton edge="end" onClick={closeCallback}>
                <HighlightOffIcon fontSize="large" />
              </IconButton>
            </Grid>
            {error && (
              <Grid className={classes.inlineGrid} item xs={12} sm={12} lg={12}>
                <Alert severity="error">
                  <FormattedMessage id="sharedScreen.thereWasAProblemCreatingAnnouncement" />
                </Alert>
              </Grid>
            )}

            <Grid item xs={6} sm={6} lg={6}>
              <TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.raffle_draw_type}
                label={formatMessage({ id: "sharedScreen.raffleDrawType" })}
                fullWidth
                name="raffle_draw_type"
                //onChange={formik.handleChange}
                onChange={(event) => onTypeChange(event.target.value)}
                error={
                  formik.touched.raffle_draw_type &&
                  Boolean(formik.errors.raffle_draw_type)
                }
                helperText={
                  formik.touched.raffle_draw_type &&
                  formik.errors.raffle_draw_type
                }
              >
                <MenuItem value={1}> NORMAL </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={6} sm={6} lg={6}>
              <TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.renew_losers}
                label={formatMessage({ id: "sharedScreen.renewLosers" })}
                fullWidth
                name="renew_losers"
                onChange={formik.handleChange}
                error={
                  formik.touched.renew_losers &&
                  Boolean(formik.errors.renew_losers)
                }
                helperText={
                  formik.touched.renew_losers && formik.errors.renew_losers
                }
              >
                <MenuItem value={0}> NO </MenuItem>
                <MenuItem value={1}> YES </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={6} sm={6} lg={6}>
              <InputField
                value={numberOfDetails}
                type="number"
                fullWidth
                //label={formatMessage({ id: "sharedScreen.announcement.description" })}
                placeholder={formatMessage({
                  id: "sharedScreen.RaffleDrawNumberOfWinners",
                })}
                name="number_of_winners"
                //onChange={formik.handleChange}
                onChange={(event) => onNumberOfWinner(event.target.value)}
                error={
                  formik.touched.number_of_winners &&
                  Boolean(formik.errors.number_of_winners)
                }
                helperText={
                  formik.touched.number_of_winners &&
                  formik.errors.number_of_winners
                }
              />
            </Grid>

            <Grid item xs={6} sm={6} lg={6}>
              <InputDate
                minDate={moment()
                  .subtract("day", 1)
                  .format("YYYY-MM-DD HH:mm:ss")}
                onDateChange={(name, date) => handleDateChange(name, date)}
                inputProps={{
                  disabled: formik.isSubmitting,
                  fullWidth: true,
                  id: "raffle_draw_date",
                  name: "raffle_draw_date",
                  placeholder: intl.formatMessage({
                    id: "sharedScreen.raffleDrawDate",
                  }),
                  endAdornment: (
                    <InputAdornment position="start">
                      <CalendarToday />
                    </InputAdornment>
                  ),
                  value: formik.values.raffle_draw_date,
                  error:
                    Boolean(formik.touched.raffle_draw_date) &&
                    Boolean(formik.errors.raffle_draw_date),
                  helperText:
                    formik.touched.raffle_draw_date &&
                    formik.errors.raffle_draw_date,
                }}
                pickerProps={{
                  format: "YYYY-MM-DD HH:mm:ss",
                  disabled: false,
                  showToday: false,
                  showTime: true,
                }}
              />
              <br />
            </Grid>
            {raffleDrawType && (
              <>
                {raffleDetails.map((valueIndex) => {
                  return (
                    <>
                      {valueIndex === 0 && (
                        <Grid item xs={12} sm={12} lg={12}>
                          <Typography
                            className={classes.detailsTitle}
                            variant="h4"
                            component="h4"
                          >
                            <FormattedMessage id="sharedScreen.RaffleDrawDetails" />
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={6} sm={6} lg={6}>
                        <InputField
                          fullWidth
                          type="number"
                          readOnly={true}
                          value={positionsTab[valueIndex]}
                          label={`${formatMessage({
                            id: "sharedScreen.raffleDrawDetailPosition",
                          })}`}
                          placeholder={`${formatMessage({
                            id: "sharedScreen.raffleDrawDetailPosition",
                          })} ${valueIndex}`}
                          name="position[]"
                          onChange={(event) =>
                            onPositionChange(valueIndex, event.target.value)
                          }
                        />
                      </Grid>

                      <Grid item xs={6} sm={6} lg={6}>
                        <TextField
                          className={classes.selectPackage}
                          select
                          variant="outlined"
                          size="small"
                          value={packagesTab[valueIndex]}
                          label={`${formatMessage({
                            id: "sharedScreen.raffleDrawPackage",
                          })}`}
                          placeholder={`${formatMessage({
                            id: "sharedScreen.raffleDrawPackage",
                          })}`}
                          fullWidth
                          name="package[]"
                          required={true}
                          onChange={(event) =>
                            onPackageChange(valueIndex, event.target.value)
                          }
                        >
                          {winningPackages.map((winningPack) => (
                            <MenuItem
                              key={winningPack.id}
                              value={winningPack.id}
                            >
                              {winningPack.designation_fr}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </>
                  );
                })}
              </>
            )}

            <Grid item xs={12} sm={12} lg={12} container direction="row">
              <InputButton
                fullWidth
                type="submit"
                variant="contained"
                color="secondary"
                onClick={saveRaffleDraw}
                disabled={savingRaffleDraw}
              >
                <FormattedMessage id="sharedScreen.create" />
                {formik.isSubmitting && <CircularProgress size={30} />}
              </InputButton>
            </Grid>
            {succeed && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="success">
                  <FormattedMessage id="sharedScreen.raffleDrawCreatedSuccessfully" />
                </Alert>
              </Grid>
            )}
          </Grid>
        </form>
      </Paper>
    </Modal>
  );
};
